<h3 class="k-mb-4">Aufwände</h3>

<kendo-chart>
  <kendo-chart-category-axis>
    <kendo-chart-category-axis-item [baseUnit]="'days'" [baseUnitStep]="1">
      <kendo-chart-category-axis-item-labels [format]="'dd'" [visible]="true">
      </kendo-chart-category-axis-item-labels>
    </kendo-chart-category-axis-item>
  </kendo-chart-category-axis>

  <kendo-chart-series>
    @for (series of data; let i = $index; track i) {
      <kendo-chart-series-item
        [stack]="true"
        [data]="series.data"
        type="column"
        categoryField="date"
        field="value"
        colorField="color"
      >
        <!-- turn on labels and bind a content callback -->
        <kendo-chart-series-item-labels
          [visible]="true"
          position="center"
          [content]="labelContent"
          [color]="'#ffffff'"
          [background]="'transparent'"
        >
        </kendo-chart-series-item-labels>
      </kendo-chart-series-item>
      <kendo-chart-tooltip></kendo-chart-tooltip>
    }
  </kendo-chart-series>
</kendo-chart>
